import { useTranslation } from "react-i18next";

export const Disclaimers = () => {
    const { t } = useTranslation();
    const urlDataProcessingAgreement =
        "https://www.wwimmo.ch/wp-content/uploads/2023/06/Auftragsverarbeitungsvertrag.pdf";
    return (
        <div>
            <h4>{t("disclaimer.title1")}</h4>
            <p>{t("disclaimer.paragraph1")}</p>
            <h4>{t("disclaimer.title2")}</h4>
            <p>{t("disclaimer.paragraph2")}</p>
            <h4>{t("disclaimer.title3")}</h4>
            <p>
                {t("disclaimer.paragraph3")}{" "}
                <a
                    href={urlDataProcessingAgreement}
                    className="link-underline"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {t("disclaimer.data_processing_agreement")}
                </a>{" "}
                {t("disclaimer.restOfParagraph3")}
            </p>
        </div>
    );
};
